
export * from 'utils/gqlTypes';

//
// Some standard types to simplify larger complex types
//
export enum RenewInterval {
	MONTH = 'MONTH',
	QUARTER = 'QUARTER',
}

export interface QuantityTotal {
	quantity: number
	total: number
}

export interface Membership {
	renewInterval: RenewInterval
	price: QuantityTotal
}
